import { render } from "./Education.vue?vue&type=template&id=471079a8&scoped=true"
const script = {}

import "./Education.vue?vue&type=style&index=0&id=471079a8&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src286570729/src/astaykov-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-471079a8"]])

export default __exports__